<div 
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();"
>
    <div class="flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg"> 
            <form 
                (ngSubmit)="$event.preventDefault(); saveEdit();"
                [formGroup]="threatForm"
                class="w-full flex flex-col items-center justify-start gap-4"
            >           
            <!-- <div class="w-full flex flex-col items-center justify-start gap-4"> -->
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        Edit Threat or Hazard
                    </h2>                    
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeModal();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full flex flex-col items-center gap-2 pb-4 border-b border-gray-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Threat:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input noEmoji 
                                type="text"
                                formControlName="threat"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g., Fire"
                            >
                            <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="threatForm.get('threat')?.invalid && (threatForm.get('threat')?.touched || threatForm.get('threat')?.dirty)"
                            >
                                <div *ngIf="threatForm.get('threat')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Probability:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <select
                                formControlName="probability"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2.">
                                <option value='Highly likely'>Highly likely</option>
                                <option value='Likely'>Likely</option>
                                <option value='Possible'>Possible</option>
                                <option value='Unlikely'>Unlikely</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Magnitude:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <select
                                formControlName="magnitude"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2.">
                                <option value='Catastrophic'>Catastrophic</option>
                                <option value='Critical'>Critical</option>
                                <option value='Limited'>Limited</option>
                                <option value='Negligible'>Negligible</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Warning:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <select
                                formControlName="warning"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2.">
                                <option value='Minimal'>Minimal</option>
                                <option value='6-12 hrs'>6-12 hrs</option>
                                <option value='12-24 hrs'>12-24 hrs</option>
                                <option value='24+ hrs'>24+ hrs</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Duration:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <select
                                formControlName="duration"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2.">
                                <option value='12+ hrs'>12+ hrs</option>
                                <option value='6-12 hrs'>6-12 hrs</option>
                                <option value='3-6 hrs'>3-6 hrs</option>
                                <option value='< 3 hrs'>< 3 hrs</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Risk Priority:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <select
                                formControlName="risk_priority"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2.">
                                <option value='High'>High</option>
                                <option value='Medium'>Medium</option>
                                <option value='Low'>Low</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': threatForm.invalid || !threatForm.dirty,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': threatForm.valid && threatForm.dirty
                        }"
                        [disabled]="threatForm.invalid || !threatForm.dirty"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
        
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>